import React from 'react'
import Css from './FaqCard.module.scss';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqCard = ({ faq }) => {
  return (
      <Accordion key={faq.id} className={Css.faq} TransitionProps={{ unmountOnExit: true }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={Css.faq_question}
        >
          <Typography className={Css.question}>{faq.question}</Typography>
        </AccordionSummary>
        <AccordionDetails className={Css.faq_answer}>
          <Typography className="answer">
            {faq.answer}
          </Typography>
        </AccordionDetails>
      </Accordion>
  )
}

export default FaqCard
